import React from 'react'
import logo from '../images/output-onlinepngtools.png';
import face from '../images/icon-facebook.svg';
import insta from '../images/icon-instagram.svg';
import twi from '../images/icon-twitter.svg';
import pin from '../images/icon-pinterest.svg';


function Footer() {
    return (
        <div className='bg-[#232027] sm:h-[18rem] absolute sm:top-[118rem] top-[160rem] h-[54rem] w-full'>
            <img src={logo} className='absolute sm:left-[10rem] sm:top-[3.50rem] top-[3rem] left-[8rem]' />
            <p className='text-white text-lg absolute sm:top-[3.50rem] sm:left-[30rem] left-[9.50rem] top-[7rem] font-medium'>Features</p>
            <ul className='flex sm:gap-1 sm:left-[30rem] sm:top-[6rem] sm:text-[14px] flex-col sm:text-left left-[7.90rem] absolute top-[10rem] text-[rgba(255,255,255,0.8)] text-lg text-center gap-4'>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Link Shortening</li>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Branded Links</li>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Analytics</li>
            </ul>
            <p className='text-white sm:left-[44rem] sm:top-[3.50rem] text-lg absolute left-[9.50rem] top-[19rem] font-medium'>Resources</p>
            <ul className='flex flex-col sm:gap-1 left-[9.20rem] sm:text-left sm:left-[44rem] sm:top-[6rem] sm:text-[14px] absolute top-[22rem] text-[rgba(255,255,255,0.8)] text-lg text-center gap-4'>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Blog</li>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Developers</li>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Support</li>
            </ul>
            <p className='text-white sm:top-[3.50rem] sm:left-[58rem] text-lg absolute left-[9.90rem] top-[32rem] font-medium'>Company</p>
            <ul className='flex sm:gap-1 flex-col left-[9.90rem] sm:left-[58rem] sm:text-[14px] sm:text-left sm:top-[6rem] absolute top-[35rem] text-[rgba(255,255,255,0.8)] text-lg text-center gap-4'>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>About</li>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Our Team</li>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Careers</li>
                <li className='hover:cursor-pointer hover:text-[#2bd1d1]'>Contact</li>
            </ul>
            <ul className='flex sm:left-[69rem] sm:gap-6 sm:top-[3.50rem] absolute top-[48rem] left-[7.50rem] flex-row gap-4'>
                <img className='hover:opacity-20 hover:cursor-pointer' src={face} alt='facebook'/>
                <img className='hover:opacity-20 hover:cursor-pointer' src={twi} alt='twitter'/>
                <img className='hover:opacity-20 hover:cursor-pointer' src={pin} alt='pininterest'/>
                <img className='hover:opacity-20 hover:cursor-pointer' src={insta} alt='instagram'/>
                
            </ul>
        </div>
    )
}

export default Footer